/**
 * Unified (inch) thread size → metric equivalent for the Selector's
 * "Maximum thread size" filter (MICS-164, Lars Q7a). Machine capacity stays
 * metric (`products_with_key_characteristics.max_size`, integer): choosing a
 * unified size filters by its metric equivalent, so the selector contract is
 * unchanged. Filtering only — never a cost input (§D.4).
 *
 * Every unified thread in the PEM catalogue (S/SS/CLS/CLSS/SP nut table and the
 * fastener catalogue's thread codes) plus 5/8-11 and 3/4-10, each mapped to the
 * nearest size on the metric ladder. Approved by Lars 2026-10-12 (MICS-164).
 * Region gating hides any size no machine in the region reaches.
 */
export interface UnifiedThreadSize {
  /** Catalogue designation, shown as the option label. */
  readonly label: string;
  /** Metric equivalent sent as `maxThreadSize`. */
  readonly metricSize: number;
}

export const UNIFIED_THREAD_SIZES: readonly UnifiedThreadSize[] = [
  { label: "#2-56", metricSize: 2 },
  { label: "#3-48", metricSize: 3 },
  { label: "#4-40", metricSize: 3 },
  { label: "#6-32", metricSize: 4 },
  { label: "#8-32", metricSize: 4 },
  { label: "#10-24", metricSize: 5 },
  { label: "#10-32", metricSize: 5 },
  { label: "#12-24", metricSize: 5 },
  { label: "1/4-20", metricSize: 6 },
  { label: "1/4-28", metricSize: 6 },
  { label: "5/16-18", metricSize: 8 },
  { label: "5/16-24", metricSize: 8 },
  { label: "3/8-16", metricSize: 10 },
  { label: "3/8-24", metricSize: 10 },
  { label: "7/16-20", metricSize: 12 },
  { label: "1/2-13", metricSize: 12 },
  { label: "1/2-20", metricSize: 12 },
  { label: "5/8-11", metricSize: 16 },
  { label: "3/4-10", metricSize: 20 },
];
